import React, { useEffect, useRef } from 'react';
import './ContactSection.css';

const ContactSection = () => {
  const contactRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('reveal-now');
          } else {
            entry.target.classList.remove('reveal-now');
          }
        });
      },
      { threshold: 0.1 }
    );

    const items = contactRef.current.querySelectorAll('.animate-contact');
    items.forEach((item) => observer.observe(item));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="contact-premium" id="contact" ref={contactRef}>
      <div className="contact-wrapper">
        
        <div className="contact-header animate-contact">
          <span className="tag">Get In Touch</span>
          <h2>Contact <span>The Doctor At Home</span></h2>
          <div className="h-line"></div>
        </div>

        <div className="contact-grid">
          <div className="info-side animate-contact delay-1">
            {/* Class name wahi hai, bas link add kiya hai */}
            <a href="mailto:thedoctorathome2@gmail.com" className="info-card">
              <div className="icon-box">✉️</div>
              <div className="text-box">
                <h4>Email Us</h4>
                <p>thedoctorathome2@gmail.com</p>
              </div>
            </a>

            <a href="tel:+916354355617" className="info-card">
              <div className="icon-box">📞</div>
              <div className="text-box">
                <h4>Call Support</h4>
                <p>+91 635 435 5617</p>
              </div>
            </a>

            <a href="https://www.thedoctorathome.in" target="_blank" rel="noreferrer" className="info-card">
              <div className="icon-box">🌐</div>
              <div className="text-box">
                <h4>Visit Website</h4>
                <p>www.thedoctorathome.in</p>
              </div>
            </a>
          </div>

          <div className="brand-side animate-contact delay-2">
            <div className="support-badge">
              <div className="pulse-icon"></div>
              <span>24/7 Support Available</span>
            </div>
            <h3>Need Quick Help?</h3>
            <p>Our team is always available via call, chat, or email for any assistance.</p>
            <a href="https://wa.me/916354355617" className="contact-btn">Chat on WhatsApp</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;